import { render } from "./ProgramsDetails.vue?vue&type=template&id=7483cf5d&scoped=true"
import script from "./ProgramsDetails.vue?vue&type=script&lang=js"
export * from "./ProgramsDetails.vue?vue&type=script&lang=js"

import "./ProgramsDetails.vue?vue&type=style&index=0&id=7483cf5d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7483cf5d"]])

export default __exports__